import {
  FETCH_SPIN_WRITING_ASSIGNMENT_SUCCESS,
} from './actions';
import Spin from './model';
import { List, Map } from 'immutable';

export default function SpinReducer(state = new Map(), action) {
  switch (action.type) {
    case FETCH_SPIN_WRITING_ASSIGNMENT_SUCCESS:
      return state.set(`${action.groupId}`, onSuccess(action.payload));
    default:
      return state;
  }
}

function onSuccess(response) {
  return response.reduce((list, item) => list.push(Spin.create(item)), new List());
}



// WEBPACK FOOTER //
// ./data/WritingAssignment/SPIN/reducer.js